import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  div_spinner: {
    paddingTop: '20px',
    paddingBottom: '20px',
  },
  spinner: {
    color: theme.palette.primary.main,
  },
}));

// `className` *replaces* `div_spinner`, it does not add to it: the 20px of
// vertical padding are right for a spinner that stands alone in a column, and
// wrong for one inline in a row of buttons, where they would grow the row by
// 40px. Omitting it keeps today's spacing, so the existing callers are untouched.
export default function SpinnerComponent({ className, size }) {
  const classes = useStyles();

  return (
    <div className={className ?? classes.div_spinner}>
      <CircularProgress disableShrink className={classes.spinner} size={size} />
    </div>
  );
}

SpinnerComponent.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number.isRequired,
};
